// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/no-unused-prop-types */
import type { Dispatch } from "redux"
import * as React from "react"
import { connect } from "react-redux"
// @ts-expect-error: Flow to TS migration.
import type { Connector } from "react-redux"

import SmartFAQApp from "@kiwicom/smart-faq-sidebar/lib/app/HelpSidebarApp"
import HelpSidebarDrawer from "@kiwicom/smart-faq-sidebar/lib/app/HelpSidebarDrawer"
import { toggleSmartFAQ as toggleSmartFAQAction, HelpArticle } from "./services/SmartFAQDuck"
import { bannersConfigSelector } from "../../services/remoteConfig"
import maybeTranslate from "../../../../app/scripts/tools/maybeTranslate"
import { hideModal } from "../../services/modals/actions"
import type { ModalsState } from "../../services/modals/reducer"
import { bidSelector } from "../../services/booking/booking"

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type OwnProps = Record<any, any>

type ContainerHandlers = {
  toggleSmartFAQ: (arg1: boolean) => void
  hideBanner: () => void
}

type ContainerProps = {
  isOpen: boolean
  article: HelpArticle | null | undefined
  banners: string[]
  bid: number | null | undefined
  // @ts-expect-error: Flow to TS migration.
  modals: ModalsState
}

type Props = OwnProps & ContainerProps & ContainerHandlers

const SmartFAQHelp = ({ toggleSmartFAQ, isOpen, article, banners, bid }: Props) => {
  const onToggle = (shouldBeOpen: boolean) => {
    toggleSmartFAQ(shouldBeOpen)
  }

  return (
    // this is needed because of the hack in
    // src/common/components/OrbitModalWrapper/OrbitModalWrapper.js#L122
    <div style={{ position: "relative", zIndex: 6041 }}>
      <HelpSidebarDrawer isShown={isOpen} onClose={() => onToggle(false)}>
        <SmartFAQApp
          isOpen={isOpen}
          initialBookingId={bid ?? 0}
          // @ts-expect-error: Flow to TS migration.
          openArticle={article && String(article.id)}
          emergencies={banners}
          onToggle={onToggle}
          disableSentry
        />
      </HelpSidebarDrawer>
    </div>
  )
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapStateToProps = (state: any): ContainerProps => {
  const rawBid = bidSelector(state)
  const bid = Number.isFinite(rawBid) ? rawBid : null

  const bannersConfig = bannersConfigSelector(state)
  const widgetState = state.smartFAQ.widget

  return {
    modals: state.modals,
    bid,
    banners: bannersConfig.banners.map(maybeTranslate),
    isOpen: widgetState.open,
    article: widgetState.article,
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps: (arg1: Dispatch<any>) => ContainerHandlers = (dispatch) => ({
  toggleSmartFAQ: (shouldBeOpen: boolean) => dispatch(toggleSmartFAQAction(shouldBeOpen)),
  hideBanner: () => dispatch(hideModal("exponea")),
})

const connector: Connector<OwnProps, Props> = connect(mapStateToProps, mapDispatchToProps)

const SmartFAQ = connector(SmartFAQHelp)

export default SmartFAQ
